import { useEffect } from 'react';
import { JSONValidator } from '@components/Inputs';
import { Grid, TextInput } from '@ts/storybook';
import { CDeliveryChain, IForm } from '@ts/ui-models';

interface IDiscoveryRtlsAppOptionsProps extends IForm {
  values: CDeliveryChain;
}
const DiscoveryRtlsAppOptions = (props: IDiscoveryRtlsAppOptionsProps) => {
  const { values, onCallbackChange } = props;
  const isViewMode = props.mode == 'view';
  const transporterId = values.transporterId;

  //Function to check that the prefix is 12 uppercase hex characters
  const onChangePrefix = value => {
    if (value.length > 12) {
      return;
    }
    if (value.match(/^[0-9A-F]*$/)) {
      onCallbackChange('parameters.mainUniqueIdPrefix')(value);
    }
  };

  const renderDiscoveryRTLSAppOptions = () => {
    return (
      <>
        <TextInput
          isReadOnly={isViewMode}
          label="Tag ID prefix"
          value={values.parameters?.mainUniqueIdPrefix}
          onChangeValue={onChangePrefix}
          required
          placeholder="12 uppercase hex characters"
          inputProps={{
            title: '12 uppercase hex characters',
            minLength: 12,
            maxLength: 12,
          }}
        />

        <JSONValidator
          isSubtitle
          value={values.parameters?.sensorPlacementSettings}
          disabled={isViewMode}
          label={'Sensor placement settings'}
          onJSONValidated={onCallbackChange('parameters.sensorPlacementSettings')}
        />
      </>
    );
  };

  const renderOptions = () => {
    switch (transporterId) {
      case 'discoveryRTLSApp':
        return renderDiscoveryRTLSAppOptions();
      default:
        return;
    }
  };

  if (!transporterId) return;
  return <>{renderOptions()}</>;
};

export default DiscoveryRtlsAppOptions;
